import React from 'react'
import { ATLTextBody } from '@appsimples/atlantica-react-native'
import { formatMessage } from '../../constants/strings/intl/intlHooks'
import { messages } from '../../constants/strings/messages'
import { atlTheme } from '../../atlTheme'

export const RaffleEmptyState: React.FC = () => {
  return (
    <ATLTextBody labelBaseProps={{ textColor: atlTheme.ColorMediumContrast, multilineLimit: 2 }}>
      {formatMessage(messages.appointments_noRaffles)}
    </ATLTextBody>
  )
}
